import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { EnergyMeterService } from "../../../../app/services/energymeter.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-meter-operational-kpis",
  templateUrl: "./meter-operational-kpis.component.html",
  styleUrls: ["./meter-operational-kpis.component.scss"],
  standalone: true,
  imports: [CommonModule]
})
export class MeterOperationalKpisComponent implements OnInit,OnDestroy {
  public emeterData = BaseUrlConstantsService.energyMeterApi;

  public meterData: {
    generic_asset_id: any; client_id: string; serial_number: string 
};
  public meterDataSub=new Subscription();
  public kpiData: any;
  public kpiLoader = true;
  public kpiDataErr = false;

  constructor(private service: EnergyMeterService) {}

  ngOnInit(): void {
    this.meterDataSub=this.service.meterDataObs.subscribe((data) => {
      this.meterData = data;
      if(data.client_id){
        this.getOperationalKpis();
      }
    });
  }

  ngOnDestroy(): void {
    this.meterDataSub.unsubscribe();
  }

  getOperationalKpis() {
    this.service
      .getOperationalKPIs(`${this.emeterData}/get-new-data/${this.meterData.client_id}/${this.meterData.generic_asset_id}`)
      .then((data) => {
        this.kpiData = data;
        this.kpiDataErr = false;
      })
      .catch((err) => {
        this.kpiDataErr = true;
      })
      .finally(() => {
        this.kpiLoader = false;
      });
  }
}
